import { Dialog, DialogTrigger, Modal, ModalOverlay } from "react-aria-components";

export type DrawerProps = {
  isOpen?: boolean;
  portalContainerRef?: React.RefObject<HTMLElement>;
  onOpenChange?: (isOpen: boolean) => void;
  trigger: React.ReactNode;
  children: (close: () => void) => React.ReactNode;
};

export const Drawer = ({ isOpen, portalContainerRef, onOpenChange, trigger, children }: DrawerProps) => {
  return (
    <DialogTrigger
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      {trigger}
      <ModalOverlay
        UNSTABLE_portalContainer={portalContainerRef?.current || undefined}
        className="bg-interactive-primary-idle"
      >
        <Modal className="fixed top-0 right-0 bottom-0 z-40 h-[100svh] w-screen entering:animate-drawer-enter-right exiting:animate-drawer-exit-right bg-elevation-background">
          <Dialog className="outline-none">{({ close }) => children(close)}</Dialog>
        </Modal>
      </ModalOverlay>
    </DialogTrigger>
  );
};
